import { render, staticRenderFns } from "./ProvideEmail.vue?vue&type=template&id=55d48087&scoped=true&"
import script from "./ProvideEmail.vue?vue&type=script&lang=js&"
export * from "./ProvideEmail.vue?vue&type=script&lang=js&"
import style0 from "./ProvideEmail.vue?vue&type=style&index=0&id=55d48087&lang=scss&scoped=true&"
import style1 from "./ProvideEmail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d48087",
  null
  
)

export default component.exports